module.exports = __webpack_public_path__ + "static/media/TICTAC.710dd1e2.png";